import CrowdfundingBanner from './CrowdfundingBanner.vue';
import ProjectCommentsContent from './ProjectCommentsContent.vue';
import ProjectContent from './ProjectContent.vue';
import ProjectFaqContent from './ProjectFaqContent.vue';
import ProjectPledgeContent from './ProjectPledgeContent.vue';
import ProjectRewardsContent from './ProjectRewardsContent.vue';
import ProjectUpdateContent from './ProjectUpdateContent.vue';
import ProjectUpdatesContent from './ProjectUpdatesContent.vue';
import ProjectTryItContent from './ProjectTryItContent.vue';
import MiniWizardManager from './MiniWizard/MiniWizardManager.vue';
import ProjectNavigation from './ProjectNavigation.vue';
import ProjectTestMode from './ProjectTestMode/ProjectTestMode.vue';
import ProjectProductCardList from './ProjectProductCardList.vue';
import ProjectRecommendations from './Recommendations/ProjectRecommendations.vue';
import StoreContent from '@/Components/Projects/Store/StoreContent.vue';
import LegacyProjectUserPledges from '@/Components/Legacy/LegacyProjectUserPledges.vue';

export default {
    CrowdfundingBanner,
    ProjectCommentsContent,
    ProjectContent,
    ProjectFaqContent,
    ProjectPledgeContent,
    ProjectRewardsContent,
    ProjectUpdateContent,
    ProjectUpdatesContent,
    ProjectTryItContent,
    MiniWizardManager,
    ProjectNavigation,
    ProjectTestMode,
    ProjectProductCardList,
    ProjectRecommendations,
    StoreContent,
    LegacyProjectUserPledges,
};
